export default "__VITE_ASSET__Cr8nmV37__"